"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.digitacao = void 0;
const keysNumeric = [
    'exame',
    'faltas',
    'ma',
    'media',
    'mf',
    'nota',
    'recBim',
    'recFinal',
    'recSem',
    'rs1',
    'rs2',
    'soma',
];
const isNumericValue = (key, field) => {
    if (keysNumeric.includes(key))
        return true;
    if (typeof field == 'object' && 'nota' in field)
        return true;
    return false;
};
const getText = (text) => {
    var _a;
    let pureText = '';
    if (typeof text == 'object' && 'nota' in text) {
        pureText = (_a = text.nota) !== null && _a !== void 0 ? _a : '';
    }
    else if (text != undefined && ['string', 'number', 'boolean'].includes(typeof text)) {
        pureText = text.toString();
    }
    return pureText;
};
exports.digitacao = {
    getText,
    isNumericValue,
    keysNumeric,
};
